import { DictionariesCreatePage } from 'features/dictionaries/components/DictionariesCreatePage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesVehicleCreatePage = () => {
  return <DictionariesCreatePage type={DictionaryType.Vehicle} />
}
